<template>
    <button class="btn btn-primary" @click="KelasMakMinData">
        <slot><i class="fas fa-cubes"></i></slot>
    </button>
</template>

<script>
    import { EventBus } from '../eventBus.js';

    export default{
        //extends: ExampleComponent,
        props: ['id', 'name'],
        methods: {
            KelasMakMinData() {
                // alert(`I am ${this.name}!`)
                EventBus.$emit('kelasMakMinValue', this.id,this.name) 
            }
        },
    }
</script>